module.exports = __webpack_public_path__ + "img/Anhänger_Rettungshunde.e53d8e72.svg";